import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ErrorLayout, PageContext } from '@axiom/ui';

/**
 * @param {{ name?: string }} props
 */
export const NotFoundPage = ({ name } = {}) => {
  const { setTitle } = useContext(PageContext);
  setTitle('Not Found');
  return (
    <ErrorLayout errorMessage="Page not found. Please try something else" />
  );
};

NotFoundPage.propTypes = {
  name: PropTypes.string,
};
